import React from "react";
import { BsArrowDownShort, BsArrowUpShort } from "react-icons/bs";
import {
	getTrendClassName,
	getTrendLabel,
	hasTrend,
	isFallingTrend
} from "../../utils/dashboard-trend-utils";
import "./sales-summary.css";

const DashboardVariluxSummary = ({
	varilux = {},
	isClosedCycle = false
}) => {
	const isAboveGoal = Boolean(varilux?.isAboveGoal);
	const variluxTrend = varilux?.trend || varilux?.tendencia;
	const isVariluxFalling = isFallingTrend(variluxTrend);
	const TrendIcon = isVariluxFalling ? BsArrowDownShort : BsArrowUpShort;

	if (isClosedCycle) {
		return (
			<div className="dashboard-sales-summary dashboard-sales-summary--varilux">
				<div className="dashboard-sales-summary__projection">
					<span>Resultado de Varilux no ciclo:</span>

					<strong
						className={[
							"dashboard-sales-summary__projection-value",
							isAboveGoal
								? "dashboard-sales-summary__projection-value--success"
								: "dashboard-sales-summary__projection-value--danger"
						].join(" ")}
					>
						{isAboveGoal ? "Acima da meta" : "Abaixo da meta"}
					</strong>
				</div>

				<div className="dashboard-sales-summary__metrics">
					<p>
						<span>Média acumulada no ciclo:</span>
						<strong>{varilux?.projectedAccumulatedAverage ?? 0}</strong>
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="dashboard-sales-summary dashboard-sales-summary--varilux">
			<div className="dashboard-sales-summary__projection">
				<span>Projeção de Varilux no ciclo:</span>

				<strong
					className={[
						"dashboard-sales-summary__projection-value",
						isAboveGoal
							? "dashboard-sales-summary__projection-value--success"
							: "dashboard-sales-summary__projection-value--danger"
					].join(" ")}
				>
					{isAboveGoal ? "Acima da meta" : "Abaixo da meta"}
				</strong>
			</div>

			<div className="dashboard-sales-summary__metrics">
				<p>
					<span>Pares atuais no mês:</span>
					<strong>{varilux?.monthPairs ?? 0}</strong>
				</p>

				<p className="dashboard-sales-summary__metric--highlight">
					<span className="dashboard-sales-summary__metric-main">
						<span>Projeção de pares no fim do mês:</span>

						<span className="dashboard-sales-summary__metric-result">
							<strong>{varilux?.endMonthProjection ?? 0}</strong>

							{hasTrend(variluxTrend) && (
								<span className={getTrendClassName(variluxTrend)}>
									<TrendIcon size={18} />
									<span>{getTrendLabel(variluxTrend)}</span>
								</span>
							)}
						</span>
					</span>
				</p>
			</div>
		</div>
	);
};

export default DashboardVariluxSummary;